import React, { FC, useEffect, useState } from 'react';
import { I18n } from '@fiverr-private/fiverr_context';
import { stringToLink } from '../../../../shared/utils/stringToLink';

import './SidebarTOC.scss';

interface TocLink {
  id: string;
  tag: string;
  text: string;
  link: string;
}

const ARTICLE_BODY_SELECTOR = '.article-body';

const SidebarTOC: FC = () => {
  const [links, setLinks] = useState<TocLink[]>([]);

  useEffect(() => {
    const body = document.querySelector(ARTICLE_BODY_SELECTOR);
    if (!body) {
      return;
    }

    const headings = Array.from(body.querySelectorAll<HTMLElement>('h2, h3'));
    const built = headings.map((el) => {
      const text = el.textContent?.trim() ?? '';
      const id = el.id || stringToLink(text);
      if (!el.id) {
        el.id = id;
      }

      return { id, tag: el.tagName.toLowerCase(), text, link: `#${id}` };
    });

    setLinks(built);
  }, []);

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, targetId: string) => {
    e.preventDefault();
    document.getElementById(targetId)?.scrollIntoView({ behavior: 'smooth' });
    window.history.pushState(null, '', `#${targetId}`);
  };

  if (!links.length) {
    return null;
  }

  return (
    <div className="sidebar-toc">
      <h5 className="sidebar-toc__title">
        <I18n k="fiverr_guides.navbar.toc.label" />
      </h5>
      <ul className="sidebar-toc__list">
        {links.map((l) => (
          <li key={l.id} className={`sidebar-toc__item${l.tag === 'h3' ? ' sidebar-toc__item--sub' : ''}`}>
            <a
              href={l.link}
              title={l.text}
              onClick={(e: React.MouseEvent<HTMLAnchorElement>) => handleLinkClick(e, l.id)}
            >
              {l.text}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SidebarTOC;
